<template src="@/components/TopBar.html" />
<style lang="scss" scoped src="@/components/TopBar.scss" />

<script>
import {SfButton, SfSelect, SfLink} from '@storefront-ui/vue';
import { configuration } from "@/config/InstanceConfiguration";
import i18n from "@/config/i18n";
import router from "@/config/router";

export default {
  name: 'TopBar',
  components: {
    SfButton,
    SfSelect,
    SfLink
  },
  computed: {
    rootCategoryLabel: function() { return this.rootCategory && this.rootCategories.find(category => category.path === this.rootCategory).label || null; },
    rootCategories: function() { return this.$store.getters.getRootCategories; },
    rootCategory: function() { return this.$store.getters.getRootCategoryPath; },
    locale: function() { return this.$i18n.locale; },
    isMultilanguage: function() { return configuration.mode.multilanguage; },
    showSupport: () => configuration.header.showSupport,
    supportTelNumber: () => configuration.header.supportTelNumber
  },
  methods:{
    setRootCategory(rootCategoryPath) {
        this.$store.dispatch('setRootCategoryPath', rootCategoryPath)
            .then(() => {
            const rootCategory = this.rootCategories.find(c => c.path === rootCategoryPath);

            if (rootCategory) {
              router.push({name: "DefaultHome"});
            }
          });
    },
  }
};
</script>